import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'question-boolean',
  styleUrl: 'question-boolean.css',
})
export class QuestionBoolean {
  @Prop() errorMessage: string = '';
  @Prop() hasError: boolean = false;
  @Prop() isDirty: boolean = false;
  @Prop() answer: { value: string | boolean; comment?: string } = { value: undefined };
  @Prop() hasComment: boolean = false;
  @Prop() heading: string = '';
  @Prop() questionId: string = '';
  @Prop() canonicalName: string = '';
  @Prop() fieldName: string = '';
  @Prop() subHeading: string = '';
  @Prop() whenChanged: (value: boolean) => void = () => {};
  @Prop() inputStyle: 'toggleselect' | 'checkbox' | 'radio' = 'toggleselect';
  @Prop() showXLText: boolean = false;
  @Prop() dataTestId: string = '';
  @Prop() isLocked: boolean = false;

  handleChange = (value) => {
    if (this.hasError) {
      this.hasError = false;
    }
    this.whenChanged(value);
  };

  render() {
    if (this.inputStyle === 'radio') {
      // TODO: really shouldn't be doing the reshaping here in the view. should re-model
      // the answers inside the store and push reshaping into the actions and down through hydrator
      const options = [
        { label: 'Yes', value: true, selected: this.answer.value === true },
        { label: 'No', value: false, selected: this.answer.value === false },
      ];
      const dataTestIdEnum = this.dataTestId ? `${this.dataTestId}Enum` : null;
      return (
        <question-enum
          heading={this.heading}
          subHeading={this.subHeading}
          questionId={this.questionId} // always top level, qRef does not apply
          optionAnswers={options}
          isDirty={this.isDirty}
          errorMessage={this.errorMessage}
          hasError={this.hasError}
          showXLText={this.showXLText}
          whenChanged={this.whenChanged}
          data-testId={dataTestIdEnum}
          dataTestId={this.dataTestId}
          isLocked={this.isLocked}
        />
      );
    }
    const dataTestIdToggleSelect = this.dataTestId ? `${this.dataTestId}Enum` : null;
    return (
      <div>
        <div class="flex flex-wrap">
          <question-toggleselect
            inputStyle={this.inputStyle}
            questionId={this.questionId}
            canonicalName={this.canonicalName}
            fieldName={this.fieldName}
            heading={this.heading}
            subHeading={this.subHeading}
            hasComment={this.hasComment}
            errorMessage={this.errorMessage}
            hasError={this.hasError}
            isDirty={this.isDirty}
            answer={this.answer}
            whenChanged={(value) => this.handleChange(value)}
            class="mr-2 mb-2"
            data-testId={dataTestIdToggleSelect}
            dataTestId={this.dataTestId}
          />
        </div>
      </div>
    );
  }
}
